<div class="pt-4 pl-md-4 mb-6 mr-lg-7 mr-md-6">

  <h2 *ngIf="saleNotFound">Sale not found</h2>

  <h2 *ngIf="serverError !== null">Server Error: {{ serverError }}</h2>

  <ng-container *ngIf="sale === null">

    <h2 *ngIf="loadingSale">Loading...</h2>

    <ng-container *ngIf="(serverError === null) && !saleNotFound && !loadingSale">

      <h2>New Sale</h2>

      <label>Purchasing Customer</label>

      <div class="d-block">
        <button class="btn btn-primary"
                type="button"
                (click)="openSelectCustomerModal()">
          Select Customer
        </button>
        <button class="btn btn-primary ml-2"
                type="button"
                (click)="openCreateCustomerModal()">
          Create New Customer
        </button>
      </div>

      <div class="alert alert-danger" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

    </ng-container>

  </ng-container>

  <ng-container *ngIf="sale !== null">

    <a class="btn btn-primary float-right"
       *ngIf="sale.status === InvoiceStatus.paymentComplete"
       href="#"
       (click)="$event.preventDefault(); openNewSale();">
      New Sale
    </a>

    <h2 *ngIf="sale.status === InvoiceStatus.paymentPending">New Sale</h2>
    <h2 *ngIf="sale.status === InvoiceStatus.paymentComplete">Sale Complete</h2>
    <h2 *ngIf="sale.status === InvoiceStatus.cancelled">Sale Cancelled</h2>

    <div class="row">

      <div class="col-md-6">

        <label class="mb-0">Purchasing Customer</label>

        <div class="d-flex">

          <div class="float-left">
            <img *ngIf="!sale.customer_profile_image_url"
                 src="/assets/images/photo_placeholder.png"
                 class="customer-photo my-2"
                 alt="Customer profile image">
            <img *ngIf="sale.customer_profile_image_url"
                 [src]="sale.customer_profile_image_url"
                 class="customer-photo my-2"
                 alt="Customer profile image">
          </div>

          <div class="ml-2">

            <h5 class="mt-2 mb-0"><b>
              <a routerLink="/customers/{{ sale.customer_id }}"
                 target="_blank">
                {{ sale.customer_first_name }} {{ sale.customer_last_name }}
              </a>
            </b></h5>

            <p class="mb-0">
              {{ dateStringFromISO8601(sale.customer_birthday) }}
              <br>
              <span *ngIf="sale.customer_email">
                {{ sale.customer_email }}
              </span>
              <span *ngIf="!sale.customer_email" class="text-muted">
                No email address
              </span>
            </p>

            <div class="mt-1">

              <ng-container *ngIf="customerDetailsLoaded(sale.customer_id)">
                <div *ngIf="customers[sale.customer_id].has_medical_notes"
                     ngbTooltip="Has medical notes"
                     class="d-inline">
                  <app-medical-notes-icon [size]="0"></app-medical-notes-icon>
                </div>
                <div *ngIf="customerProfileDetails[sale.customer_id].has_alert_icon"
                     ngbTooltip="Has a profile alert"
                     class="d-inline">
                  <app-alert-icon [size]="0"></app-alert-icon>
                </div>
                <div *ngFor="let proficiency of customerProfileDetails[sale.customer_id].active_proficiencies"
                     class="d-inline"
                     [ngbTooltip]="proficiency.proficiency_name">
                  <app-proficiency-icon [colorHex]="proficiency.proficiency_icon_color_hex"
                                        [iconInitials]="proficiency.proficiency_icon_initials"
                                        [size]="0">
                  </app-proficiency-icon>
                </div>
                <div *ngFor="let icon of customerProfileDetails[sale.customer_id].membership_icons"
                     class="d-inline"
                     [ngbTooltip]="icon.icon_hover_text">
                  <app-membership-icon [colorHex]="icon.icon_color_hex"
                                       [iconInitials]="icon.icon_initials"
                                       [size]="0"
                                       style="padding-right:1px">
                  </app-membership-icon>
                </div>
              </ng-container>

              <span *ngIf="!customerDetailsLoaded(sale.customer_id)" class="text-muted">
                Loading icons...
              </span>

            </div>

          </div>

        </div>

        <ng-container *ngIf="saleCanBeEdited()">
          <button class="btn btn-primary"
                  type="button"
                  [disabled]="loadingSale || saleCannotBeChanged()"
                  [class.disabled]="loadingSale || saleCannotBeChanged()"
                  (click)="openSelectCustomerModal()">
            Select Customer
          </button>
          <button class="btn btn-primary ml-2"
                  type="button"
                  [disabled]="loadingSale || saleCannotBeChanged()"
                  [class.disabled]="loadingSale || saleCannotBeChanged()"
                  (click)="openCreateCustomerModal()">
            Create New Customer
          </button>
        </ng-container>

        <div class="alert alert-danger mt-2" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>

        <app-live-reader-refusal-alert *ngIf="liveReaderRefusal"
                                       [refusal]="liveReaderRefusal"
                                       alertClass="alert-danger mt-2">
        </app-live-reader-refusal-alert>

      </div>

      <div class="col-md-6">
        <div class="d-flex">
          <div class="ml-auto">
            <p class="mb-0 text-right" style="font-size: 20px;">
              <b>Invoice #{{ sale.id }}</b>
            </p>
            <table style="font-size: 20px; line-height: 24px;"
                   *ngIf="sale.status === InvoiceStatus.paymentComplete">
              <tr>
                <td>Products:</td>
                <td style="min-width: 100px; text-align: end;">
                  {{ sale.line_items.length }}
                </td>
              </tr>
              <ng-container *ngIf="orgConfig && !orgConfig.price_includes_tax">
                <tr>
                  <td>Subtotal:</td>
                  <td style="text-align: end;">
                    {{ orgConfigService.formatCurrency(sale.total_amount_pre_tax) }}
                  </td>
                </tr>
                <tr>
                  <td style="height: 36px; vertical-align: bottom;">
                    Tax:
                  </td>
                  <td style="text-align: end; vertical-align: bottom;">
                    {{ orgConfigService.formatCurrency(sale.tax_amount) }}
                  </td>
                </tr>
              </ng-container>
              <tr>
                <td><b>Total:</b></td>
                <td style="text-align: end;">
                  <b>{{ orgConfigService.formatCurrency(sale.total_amount) }}</b>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

    </div>

    <ng-container *ngFor="let lineItem of sale.line_items">

      <hr>

      <div class="row">

        <div class="col-md-6">

          <h5><b>{{ lineItem.description }}</b></h5>

          <ng-container  *ngIf="propExists(lineItem.customer_id)">

            <label class="mb-1">Assigned Customer</label>

            <div class="indented-subsection">
              <h5 class="mb-0"><b>
                <a routerLink="/customers/{{ lineItem.customer_id }}"
                   target="_blank">
                  {{ lineItem.customer_first_name }} {{ lineItem.customer_last_name }}
                </a>
              </b></h5>

              <p class="mb-0">
                {{ dateStringFromISO8601(lineItem.customer_birthday) }}
                <br>
                <span *ngIf="lineItem.customer_email">
                  {{ lineItem.customer_email }}
                </span>
                <span *ngIf="!lineItem.customer_email" class="text-muted">
                  No email address
                </span>
              </p>

              <div class="mt-1" style="height: 21px;">

                <ng-container *ngIf="customerDetailsLoaded(lineItem.customer_id)">
                  <div *ngIf="customers[lineItem.customer_id].has_medical_notes"
                       ngbTooltip="Has medical notes"
                       class="d-inline">
                    <app-medical-notes-icon [size]="0"></app-medical-notes-icon>
                  </div>
                  <div *ngIf="customerProfileDetails[lineItem.customer_id].has_alert_icon"
                       ngbTooltip="Has a profile alert"
                       class="d-inline">
                    <app-alert-icon [size]="0"></app-alert-icon>
                  </div>
                  <div *ngFor="let proficiency of customerProfileDetails[lineItem.customer_id].active_proficiencies"
                       class="d-inline"
                       [ngbTooltip]="proficiency.proficiency_name">
                    <app-proficiency-icon [colorHex]="proficiency.proficiency_icon_color_hex"
                                          [iconInitials]="proficiency.proficiency_icon_initials"
                                          [size]="0">
                    </app-proficiency-icon>
                  </div>
                  <div *ngFor="let icon of customerProfileDetails[lineItem.customer_id].membership_icons"
                       class="d-inline"
                       [ngbTooltip]="icon.icon_hover_text">
                    <app-membership-icon [colorHex]="icon.icon_color_hex"
                                         [iconInitials]="icon.icon_initials"
                                         [size]="0"
                                         style="padding-right:1px">
                    </app-membership-icon>
                  </div>
                </ng-container>

                <span *ngIf="!customerDetailsLoaded(lineItem.customer_id)" class="text-muted">
                  Loading icons...
                </span>

              </div>

            </div>

          </ng-container>

          <p class="mt-3 mb-0" *ngIf="propExists(lineItem.product_start_date)">
            Start Date: {{ dateStringFromISO8601(lineItem.product_start_date) }}
            <br>
            End Date: {{ dateStringFromISO8601(lineItem.product_end_date) }}
          </p>

          <div class="mt-3" *ngIf="propExistsAndIsNonEmpty(lineItem.add_on_names)">
            <span>Add-Ons</span>
            <ul class="my-0 pl-3">
              <li *ngFor="let addOnName of lineItem.add_on_names">
                {{ addOnName }}
              </li>
            </ul>
          </div>

          <p class="mt-3 mb-0" *ngIf="propExists(lineItem.product_location_name)">
            Location: {{ lineItem.product_location_name }}
          </p>

          <div class="mt-3" *ngIf="(lineItem.terms_and_conditions_checkbox_text) && (saleCanBeEdited())">
            <b>Terms &amp; Conditions</b>
            <div class="form-check">
              <input class="form-check-input" type="checkbox"
                     id="ts-and-cs-{{ lineItem.id }}"
                     [(ngModel)]="tsAndCsCheckBoxStatuses[lineItem.id]">
              <label class="form-check-label"
                     for="ts-and-cs-{{ lineItem.id }}"
                     [innerHtml]="markdownRenderService.getRenderedInlineMarkdown(lineItem.terms_and_conditions_checkbox_text)">
              </label>
            </div>
          </div>

        </div>

        <div class="col-md-6 text-right">

          <h5 class="d-inline"><b>
            <ng-container *ngIf="orgConfig && orgConfig.price_includes_tax">
              {{ orgConfigService.formatCurrency(lineItem.amount) }}
            </ng-container>
            <ng-container *ngIf="orgConfig && !orgConfig.price_includes_tax">
              {{ orgConfigService.formatCurrency(lineItem.amount_pre_tax) }}
            </ng-container>
          </b></h5>

          <ng-container *ngFor="let disc of lineItem.discounts">
            <br>
            ({{ orgConfigService.formatCurrency(disc.amount) }} "{{ getDiscountDisplayName(disc) }}" discount applied)
          </ng-container>

          <ng-container *ngIf="saleCanBeEdited()">

            <br>

            <div class="d-inline-block mt-2">
              Discount Code:
              <input class="form-control form-control-sm d-inline"
                     style="width: 160px"
                     [disabled]="loadingSale || saleCannotBeChanged()"
                     [(ngModel)]="discountCodes[lineItem.id]">
              <br>
              <button class="btn btn-sm btn-outline-primary mt-1"
                      [disabled]="!discountCodes[lineItem.id] || loadingSale || saleCannotBeChanged()"
                      [class.disabled]="!discountCodes[lineItem.id] || loadingSale || saleCannotBeChanged()"
                      (click)="handleDiscountCodeSubmit(lineItem.id)">
                Submit
              </button>
              <p *ngIf="discountCodeSuccessMessages[lineItem.id] !== undefined" class="text-success mt-2 mb-2">
                {{ discountCodeSuccessMessages[lineItem.id] }}
              </p>
              <p *ngIf="discountCodeErrorMessages[lineItem.id] !== undefined" class="text-danger mt-2 mb-2">
                {{ discountCodeErrorMessages[lineItem.id] }}
              </p>
            </div>

          </ng-container>

        </div>

      </div>

      <div class="mt-3"
           *ngIf="saleCanBeEdited()">
        <button class="btn btn-sm btn-outline-primary"
                type="button"
                [disabled]="loadingSale || saleCannotBeChanged()"
                [class.disabled]="loadingSale || saleCannotBeChanged()"
                (click)="handleEditLineItem(lineItem)">
          Edit
        </button>
        <button class="btn btn-sm btn-outline-primary ml-2"
                type="button"
                [disabled]="loadingSale || saleCannotBeChanged()"
                [class.disabled]="loadingSale || saleCannotBeChanged()"
                (click)="handleDuplicateLineItem(lineItem)">
          Duplicate
        </button>
        <button class="btn btn-sm btn-outline-danger ml-2"
                type="button"
                [disabled]="loadingSale || saleCannotBeChanged()"
                [class.disabled]="loadingSale || saleCannotBeChanged()"
                (click)="handleRemoveLineItem(lineItem)">
          Remove
        </button>
      </div>

      <ng-container *ngIf="sale.status === InvoiceStatus.paymentComplete">

        <div class="mt-3" *ngIf="lineItem.purchase_type === LineItemPurchaseType.entryPass">
          <b>{{ lineItem.number_of_uses_remaining }}</b>
          uses remaining
        </div>

        <div class="mt-3" *ngIf="propExistsAndIsNonEmpty(lineItem.customers_checked_in_using_product)">
          Customers checked in with this pass:
          <ul>
            <li *ngFor="let c of lineItem.customers_checked_in_using_product">
              <a routerLink="/customers/{{ c.id }}"
                 target="_blank">
                {{ c.first_name }} {{ c.last_name }}
              </a>
            </li>
          </ul>
        </div>

        <div class="mt-3">
          <button class="btn btn-sm"
                  type="button"
                  *ngIf="propExists(lineItem.customer_id)"
                  [disabled]="lineItem.customer_is_checked_in || loadingSale"
                  [class.disabled]="lineItem.customer_is_checked_in || loadingSale"
                  [class.btn-outline-primary]="!lineItem.customer_is_checked_in"
                  [class.btn-success]="lineItem.customer_is_checked_in"
                  (click)="handleCheckIn(lineItem, false)">
            <ng-container *ngIf="lineItem.customer_is_checked_in">
              Checked In
            </ng-container>
            <ng-container *ngIf="!lineItem.customer_is_checked_in">
              {{ loadingSale ? 'Loading...' : 'Check In' }}
            </ng-container>
          </button>
          <button class="btn btn-sm btn-outline-primary ml-2"
                  type="button"
                  *ngIf="lineItem.purchase_type === LineItemPurchaseType.entryPass"
                  [disabled]="(lineItem.number_of_uses_remaining <= 0) || loadingSale"
                  [class.disabled]="(lineItem.number_of_uses_remaining <= 0) || loadingSale"
                  (click)="handleSharePass(lineItem, null, false)">
            {{ loadingSale ? 'Loading...' : 'Share Pass' }}
          </button>
        </div>

      </ng-container>

    </ng-container>

    <ng-container *ngIf="(saleCanBeEdited()) && (sale.line_items.length < 20)">

      <hr>

      <div class="my-4">
        <button class="btn btn-primary"
                type="button"
                [disabled]="loadingSale || loadingProductTypes() || saleCannotBeChanged()"
                [class.disabled]="loadingSale || loadingProductTypes() || saleCannotBeChanged()"
                (click)="openAddEntryPassModal()">
          Add Entry Pass
        </button>
        <button class="btn btn-primary ml-2"
                type="button"
                [disabled]="loadingSale || loadingProductTypes() || saleCannotBeChanged()"
                [class.disabled]="loadingSale || loadingProductTypes() || saleCannotBeChanged()"
                (click)="openAddMembershipModal()">
          Add Membership
        </button>
        <button class="btn btn-primary ml-2"
                type="button"
                [disabled]="loadingSale || loadingProductTypes() || saleCannotBeChanged()"
                [class.disabled]="loadingSale || loadingProductTypes() || saleCannotBeChanged()"
                (click)="openAddVoucherPackModal()">
          Add Voucher Pack
        </button>
      </div>

    </ng-container>

    <hr>

    <div class="d-flex">
      <table class="ml-auto" style="font-size: 20px; line-height: 24px;">
        <tr>
          <td>Products:</td>
          <td style="min-width: 100px; text-align: end;">
            {{ sale.line_items.length }}
          </td>
        </tr>
        <ng-container *ngIf="orgConfig && !orgConfig.price_includes_tax">
          <tr>
            <td>Subtotal:</td>
            <td style="text-align: end;">
              {{ orgConfigService.formatCurrency(sale.total_amount_pre_tax) }}
            </td>
          </tr>
          <tr>
            <td style="height: 36px; vertical-align: bottom;">
              Tax:
            </td>
            <td style="text-align: end; vertical-align: bottom;">
              {{ orgConfigService.formatCurrency(sale.tax_amount) }}
            </td>
          </tr>
        </ng-container>
        <tr>
          <td><b>Total:</b></td>
          <td style="text-align: end;">
            <b>{{ orgConfigService.formatCurrency(sale.total_amount) }}</b>
          </td>
        </tr>
        <tr *ngFor="let payment of sale.payments">
          <td>
            <a [routerLink]="['/payments']"
               [queryParams]="{paymentDetailsId: payment.id}"
               target="_blank">Payment #{{ payment.id }}</a>:
          </td>
          <td style="text-align: end; vertical-align: bottom;">
            {{ orgConfigService.formatCurrency(payment.amount) }}
          </td>
        </tr>
        <tr *ngIf="sale.total_amount !== sale.amount_due"
            style="height: 36px; vertical-align: bottom;">
          <td><b>Amount Due:</b></td>
          <td style="text-align: end;">
            <b>{{ orgConfigService.formatCurrency(sale.amount_due) }}</b>
          </td>
        </tr>
      </table>
    </div>

    <div class="alert alert-warning d-flex align-items-center w-100" *ngIf="saleIsLocked()">
      <div>
        <b>Payment in progress.</b>
        A payment of {{ orgConfigService.formatCurrency(sale.pending_payment.amount) }} was started
        {{ dateStringFromISO8601(sale.pending_payment.created_at) }} at
        {{ timeStringFromISO8601(sale.pending_payment.created_at) }} and has not finished. The sale cannot
        be changed until it completes or is discarded.
      </div>
      <button class="btn btn-outline-danger btn-sm ml-auto text-nowrap flex-shrink-0"
              type="button"
              [disabled]="loadingSale"
              [class.disabled]="loadingSale"
              (click)="handleDiscardPendingPayment()">
        Discard Pending Payment
      </button>
    </div>

    <div class="alert alert-info w-100" *ngIf="sale.status === InvoiceStatus.paymentPending && saleHasPayments() && !saleIsLocked()">
      <b>Account credit applied.</b>
      {{ orgConfigService.formatCurrency(creditAppliedTotal()) }} of account credit has been applied to this
      sale, so its items, discounts and customer can no longer be changed. Collect the remaining balance in
      Capitan, or cancel the sale to restore the credit.
    </div>

    <div *ngIf="(sale.status === InvoiceStatus.paymentPending) && (sale.line_items.length > 0)"
         class="mt-2 float-right">
      <ng-container *ngIf="sale.lightspeed_created_sale_id === ''">
        <button class="btn btn-danger"
                [disabled]="loadingSale"
                [class.disabled]="loadingSale"
                (click)="handleCancelSale()">
          Cancel
        </button>
        <button class="btn btn-primary ml-2"
                [disabled]="!canCompletePurchase() || saleIsLocked()"
                [class.disabled]="!canCompletePurchase() || saleIsLocked()"
                (click)="handleCompletePurchase()">
          Complete Purchase
        </button>
        <div *ngIf="canSendToPOS()"
             class="d-inline-block ml-2"
             [ngbTooltip]="sendToPOSTooltip()" container="body">
          <button class="btn btn-primary"
                  [disabled]="loadingSale || saleIsLocked() || saleHasPayments()"
                  [class.disabled]="loadingSale || saleIsLocked() || saleHasPayments()"
                  (click)="handleSendToPOS()">
            Send to {{ getPOSSoftwareDisplay(orgConfig.pos_software) }}
          </button>
        </div>
      </ng-container>
      <ng-container *ngIf="sale.lightspeed_created_sale_id !== ''">
        <button class="btn btn-danger"
                (click)="handleCancelPOS()">
          Cancel Lightspeed Sale
        </button>
        <a class="btn btn-primary ml-2"
           [href]="sale.lightspeed_created_sale_link"
           target="_blank">
          Open Sale In Lightspeed
        </a>
      </ng-container>
    </div>

  </ng-container>

</div>
